import request from './request';

//-----------------下载及其他列表
export function getResources(data) {
    return request({
        url: `exhibitor/file/lists?cid=${data.cid}`,
        method: 'get',
    })
}
//-----------------下载及其他分类
export function getlistCate(data) {
    return request({
        url: `exhibitor/file/listCate`,
        method: 'get',
    })
}


//---------------联系人列表
export function contactsLists(data) {
    return request({
        url: `exhibitor/Contacts/lists?${data}`,
        method: 'get',
    })
}


//---------------企业详情
export function companyInfo() {
    return request({
        url: 'exhibitor/Company/detail',
        method: 'get',
    })
}
// 新增联系人
export function addContacts(data) {
    return request({
        url: 'exhibitor/Contacts/add',
        method: 'post',
        data
    })
}

// 编辑联系人
export function editContacts(data) {
    return request({
        url: 'exhibitor/Contacts/edit',
        method: 'put',
        data
    })
}

//-----------------联系人详情
export function getContactsDetail(data) {
    return request({
        url: `exhibitor/Contacts/detail?contacts_long_id=${data.contacts_long_id}`,
        method: 'get',
    })
}


//---------------获取企业招聘列表
export function recruitList(data) {
    return request({
        url: `exhibitor/company_recruit/lists?${data}`,
        method: 'get',
    })
}

// 新增企业招聘
export function addRecruit(data) {
    return request({
        url: 'exhibitor/company_recruit/add',
        method: 'post',
        data
    })
}

// 编辑企业招聘
export function editRecruit(data) {
    return request({
        url: 'exhibitor/company_recruit/edit',
        method: 'put',
        data
    })
}
// 删除企业招聘
export function delRecruit(data) {
    return request({
        url: 'exhibitor/company_recruit/delete',
        method: 'delete',
        data
    })
}


// 获取国家省市区三级联动
export function getLocationTree(data) {
    return request({
        url: `exhibitor/company/getLocationTree?${data}`,
        method: 'get',
    })
}
// 增加参展申请
export function addcompanyApply(data) {
    return request({
        url: 'exhibitor/companyApply/add',
        method: 'post',
        data
    })
}

// 编辑参展申请
export function editcompanyApply(data) {
    return request({
        url: 'exhibitor/companyApply/edit',
        method: 'post',
        data
    })
}
// 参展申请详情
export function companyApplydetail() {
    return request({
        url: `exhibitor/companyApply/detail`,
        method: 'get',
    })
}

export function productTypelist() {
    return request({
        url: `exhibitor/ProductType/lists`,
        method: 'get',
    })
}

//---------------产品信息详情
export function productDetails(data) {
    return request({
        url: `exhibitor/product/detail?${data}`,
        method: 'get',
    })
}





//---------------发票列表
export function invoiceList(data) {
    return request({
        url: `exhibitor/Invoice/lists?${data}`,
        method: 'get',
    })
}

// 添加发票
export function addInvoice(data) {
    return request({
        url: 'exhibitor/Invoice/add',
        method: 'post',
        data
    })
}

// 编辑发票
export function editInvoice(data) {
    return request({
        url: 'exhibitor/Invoice/edit',
        method: 'put',
        data
    })
}

//---------------发票详情
export function invoiceDetails(data) {
    return request({
        url: `exhibitor/Invoice/detail?invoice_long_id=${data.invoice_long_id}`,
        method: 'get',
    })
}
//企业营业执照和产品知识产权
export function editPic(data) {
    return request({
        url: 'exhibitor/Company/editPic',
        method: 'put',
        data
    })
}
// 跳过 已知悉
export function skipOrReadStep(data) {
    return request({
        url: 'exhibitor/company_menu/skipOrReadStep',
        method: 'post',
        data
    })
}

//------------------账号密码登出
export function logOut() {
    return request({
        url: 'exhibitor/user/logout',
        method: 'get',
    })
}

// 邀请函背景图添加
export function addbackground(data) {
    return request({
        url: 'exhibitor/invitation_background/add',
        method: 'post',
        data
    })
}
// 邀请函背景图删除
export function delbackground(data) {
    return request({
        url: 'exhibitor/invitation_background/delete',
        method: 'delete',
        data
    })
}

// 邀请函背景图列表
export function backgroundList() {
    return request({
        url: `exhibitor/invitation_background/lists`,
        method: 'get',
    })
}

// 生成邀请函
export function addinvitation(data) {
    return request({
        url: 'exhibitor/invitation/add',
        method: 'post',
        data
    })
}

// 生成邀请函列表
export function invitationList() {
    return request({
        url: `exhibitor/invitation/lists`,
        method: 'get',
    })
}

// 邀请函背景图删除
export function delinvitation(data) {
    return request({
        url: 'exhibitor/invitation/delete',
        method: 'delete',
        data
    })
}

// 删除联系人
export function delContacts(data) {
    return request({
        url: 'exhibitor/Contacts/delete',
        method: 'delete',
        data
    })
}
// 展商菜单获取富文本
export function companyMenuDetail(data) {
    return request({
        url: `exhibitor/CompanyMenu/detail?id=${data.id}`,
        method: 'get',
    })
}

// 展商展示范围
export function exhibitionScope(data) {
    return request({
        url: `exhibitor/exhibition_scope/lists?page_type=0`,
        method: 'get',
    })
}

// 应用行业
export function applicationIndustry(data) {
    return request({
        url: `exhibitor/applicationIndustry/lists?page_type=0`,
        method: 'get',
    })
}

// ---------------------------------------------------
//-------------------账号密码登录
export function login(data) {
    return request({
        url: 'exhibitor/user/login',
        method: 'post',
        data
    })
}
//-------------------基本配置 左侧菜单新24.7.8
export function getmyMenu(data) {
    return request({
        url: `exhibitor/company_menu/myMenu`,
        method: 'get',
    })
}
//------------------基本配置 左侧菜单详情
export function getDetail(data) {
    return request({
        url: `exhibitor/company_menu/detail?id=${data.id}`,
        method: 'get',
    })
}
//企业信息获取选项
export function getCheckBox(data) {
    return request({
        url: `exhibitor/public/getCheckBox?filedid=${data}`,
        method: 'get',
    })
}
//企业信息详情
export function companyDetails() {
    return request({
        url: 'exhibitor/Company/detail',
        method: 'get',
    })
}
// 企业信息编辑
export function editCompany(data) {
    return request({
        url: 'exhibitor/Company/edit',
        method: 'put',
        data
    })
}
//获取产品列表
export function productList(data) {
    return request({
        url: `exhibitor/product/lists?${data}`,
        method: 'get',
    })
}
// 删除产品
export function delproduct(data) {
    return request({
        url: 'exhibitor/product/delete',
        method: 'delete',
        data
    })
}
// 批量上下架
export function upDown(data) {
    return request({
        url: 'exhibitor/product/upDown',
        method: 'put',
        data
    })
}
// 修改产品主推状态
export function storeMain(data) {
    return request({
        url: 'exhibitor/product/storeMain',
        method: 'put',
        data
    })
}
// 修改产品新品状态
export function storeNew(data) {
    return request({
        url: 'exhibitor/product/storeNew',
        method: 'put',
        data
    })
}
//获取产品详情分类
export function optionData(data) {
    return request({
        url: 'exhibitor/OptionData/lists',
        method: 'get',
    })
}
// 增加产品
export function addproduct(data) {
    return request({
        url: 'exhibitor/product/add',
        method: 'post',
        data
    })
}
// 编辑产品
export function editproduct(data) {
    return request({
        url: 'exhibitor/product/edit',
        method: 'put',
        data
    })
}
//获取展商胸卡列表
export function badgeList(data) {
    return request({
        url: `exhibitor/badge/lists?${data}`,
        method: 'get',
    })
}
// 删除展商胸卡
export function delBadge(data) {
    return request({
        url: 'exhibitor/badge/delete',
        method: 'delete',
        data
    })
}
// 编辑展商胸卡
export function editBadge(data) {
    return request({
        url: 'exhibitor/badge/edit',
        method: 'put',
        data
    })
}
//展商胸卡详情
export function badgeDetail(data) {
    return request({
        url: `exhibitor/badge/detail?${data}`,
        method: 'get',
    })
}

// 新增展商胸卡
export function addBadge(data) {
    return request({
        url: 'exhibitor/badge/add',
        method: 'post',
        data
    })
}
//获取客户胸卡列表
export function customerBadgeList(data) {
    return request({
        url: `exhibitor/customer_badge/lists?${data}`,
        method: 'get',
    })
}
// 删除客户胸卡
export function delCustomerBadge(data) {
    return request({
        url: 'exhibitor/customer_badge/delete',
        method: 'delete',
        data
    })
}
// 编辑客户胸卡
export function editcustomerBadge(data) {
    return request({
        url: 'exhibitor/customer_badge/edit',
        method: 'put',
        data
    })
}
//客户胸卡详情
export function customerBadgeDetail(data) {
    return request({
        url: `exhibitor/customer_badge/detail?${data}`,
        method: 'get',
    })
}

// 新增客户胸卡
export function addCustomerBadge(data) {
    return request({
        url: 'exhibitor/customer_badge/add',
        method: 'post',
        data
    })
}
//获取展商服务列表
export function fileShareList(data) {
    return request({
        url: `exhibitor/file_share/lists?${data}`,
        method: 'get',
    })
}



//直播列表
export function polyvList(data) {
    return request({
        url: `exhibitor/Polyv/lists?${data}`,
        method: 'get',
    })
}
//直播分类
export function getCategoryList() {
    return request({
        url: 'exhibitor/Polyv/getCategoryList',
        method: 'get',
    })
}
// 添加直播
export function polyvAdd(data) {
    return request({
        url: 'exhibitor/Polyv/add',
        method: 'post',
        data
    })
}
//编辑直播
export function polyvEdit(data) {
    return request({
        url: 'exhibitor/Polyv/edit',
        method: 'put',
        data
    })
}
//直播活动详情
export function polyvDetail(data) {
    return request({
        url: `exhibitor/Polyv/detail?${data}`,
        method: 'get',
    })
}
// 申请直播
export function applyLive(data) {
    return request({
        url: 'exhibitor/Polyv/applyLive',
        method: 'put',
        data
    })
}
//删除直播间
export function delPolyv(data) {
    return request({
        url: 'exhibitor/Polyv/delete',
        method: 'delete',
        data
    })
}
//直播状态
export function polyvLiveStatus(data) {
    return request({
        url: `exhibitor/Polyv/liveStatus?${data}`,
        method: 'get',
    })
}
//获取主讲信息
export function polyvGetTeacherInfo(data) {
    return request({
        url: `exhibitor/Polyv/getTeacherInfo?channelId=${data}`,
        method: 'get',
    })
}
//获取频道角色
export function polyvGetAccounts(data) {
    return request({
        url: `exhibitor/Polyv/getAccounts?channelId=${data}`,
        method: 'get',
    })
}
//获取第三方推流地址
export function polyvPushUrl(data) {
    return request({
        url: `exhibitor/Polyv/pushUrl?channelId=${data}`,
        method: 'get',
    })
}
//创建频道角色
export function polyvAddChannelAccount(data) {
    return request({
        url: 'exhibitor/Polyv/addChannelAccount',
        method: 'post',
        data
    })
}
//主讲修改
export function updateTeacher(data) {
    return request({
        url: 'exhibitor/Polyv/updateTeacher',
        method: 'put',
        data
    })
}
//修改频道下角色
export function updateAccount(data) {
    return request({
        url: 'exhibitor/Polyv/updateAccount',
        method: 'put',
        data
    })
}
// 删除频道角色
export function deleteAccount(data) {
    return request({
        url: 'exhibitor/Polyv/deleteAccount',
        method: 'delete',
        data
    })
}
//直播间统计数据 
export function polyvStatistic(data) {
    return request({
        url: `exhibitor/Polyv/statistic?channelId=${data}`,
        method: 'get',
    })
}
// 查询商品列表
export function polyvProductList(data) {
    return request({
        url: `exhibitor/Polyv/productList?${data}`,
        method: 'get',
    })
}
//频道添加商品
export function polyvAddProduct(data) {
    return request({
        url: 'exhibitor/Polyv/addProduct',
        method: 'post',
        data
    })
}
//查询频道商品状态
export function polyvProductEnabled(data) {
    return request({
        url: `exhibitor/Polyv/productEnabled?channelId=${data}`,
        method: 'get',
    })
}
//修改频道商品库状态 
export function polyvUpdateProductEnabled(data) {
    return request({
        url: 'exhibitor/Polyv/updateProductEnabled',
        method: 'put',
        data
    })
}
//修改商品上下架
export function polyvProductShelf(data) {
    return request({
        url: 'exhibitor/Polyv/productShelf',
        method: 'put',
        data
    })
}
//频道商品上下移 
export function polyvSortProduct(data) {
    return request({
        url: 'exhibitor/Polyv/sortProduct',
        method: 'put',
        data
    })
}
//频道推送商品
export function polyvPushProduct(data) {
    return request({
        url: 'exhibitor/Polyv/pushProduct',
        method: 'put',
        data
    })
}
//频道删除商品
export function deleteProduct(data) {
    return request({
        url: 'exhibitor/Polyv/deleteProduct',
        method: 'delete',
        data
    })
}
//查询频道暂存列表
export function polyvRecordFiles(data) {
    return request({
        url: `exhibitor/Polyv/recordFiles?channelId=${data}`,
        method: 'get',
    })
}
//查询视频库
export function polyvPlayback(data) {
    return request({
        url: `exhibitor/Polyv/playback?${data}`,
        method: 'get',
    })
}
//转存视频
export function polyvConvert(data) {
    return request({
        url: 'exhibitor/Polyv/convert',
        method: 'put',
        data
    })
}

//删除转存视频
export function deleteRecord(data) {
    return request({
        url: 'exhibitor/Polyv/deleteRecord',
        method: 'delete',
        data
    })
}
//删除视频库 
export function deletePlayback(data) {
    return request({
        url: 'exhibitor/Polyv/deletePlayback',
        method: 'delete',
        data
    })
}
//获取频道装修
export function polyvDecorate(data) {
    return request({
        url: `Polyv/getDecorate?channelId=${data}`,
        method: 'get',
    })
}
//修改直播间装修 
export function updateDecorate(data) {
    return request({
        url: 'exhibitor/Polyv/updateDecorate',
        method: 'put',
        data
    })
}
//胸卡批量勾选——参展商
export function updBoolean(data) {
    return request({
        url: 'exhibitor/badge/updBoolean',
        method: 'put',
        data
    })
}
//胸卡批量勾选——客户
export function customerBadgeUpdBoolean(data) {
    return request({
        url: 'exhibitor/customer_badge/updBoolean',
        method: 'put',
        data
    })
}
//获取询盘列表
export function seekSampleList(data) {
    return request({
        url: `exhibitor/SeekSample/lists?${data}`,
        method: 'get',
    })
}
//获取询盘详情
export function seekSampleDetail(data) {
    return request({
        url: `exhibitor/SeekSample/detail?id=${data}`,
        method: 'get',
    })
}
//访客查看-展商看板
export function getCompanyPC(data) {
    return request({
        url: `exhibitor/data_board/getCompanyPC?${data}`,
        method: 'get',
    })
}
//访客查看-产品看板
export function getProductListPC(data) {
    return request({
        url: `exhibitor/data_board/getProductListPC?${data}`,
        method: 'get',
    })
}
//邀请背景
export function invitationBgLists(data) {
    return request({
        url: `exhibitor/InvitationBackground/lists?menu_mark=${data}`,
        method: 'get',
    })
}
//添加邀请函背景
export function invitationBgAdd(data) {
    return request({
        url: 'exhibitor/InvitationBackground/add',
        method: 'post',
        data
    })
}
//删除邀请函背景
export function invitationBgDelete(data) {
    return request({
        url: 'exhibitor/InvitationBackground/delete',
        method: 'delete',
        data
    })
}
//展商邀请函列表
export function invitationLists(data) {
    return request({
        url: `exhibitor/Invitation/lists?menu_mark=${data}`,
        method: 'get',
    })
}
//展商添加邀请函
export function invitationAdd(data) {
    return request({
        url: 'exhibitor/Invitation/add',
        method: 'post',
        data
    })
}
//展商删除邀请函
export function invitationDelete(data) {
    return request({
        url: 'exhibitor/Invitation/delete',
        method: 'delete',
        data
    })
}
//邀请函渠道预登记链接
export function registrationUrl(data) {
    return request({
        url: `exhibitor/StarBall/registrationUrl?${data}`,
        method: 'get',
    })
}
//邀请函预登记观众列表
export function starAudienceList(data) {
    return request({
        url: `exhibitor/StarBall/audienceList?${data}`,
        method: 'get',
    })
}
//邀请函预登记观众列表
export function statistics(data) {
    return request({
        url: `exhibitor/StarBall/statistics?${data}`,
        method: 'get',
    })
}


//获取评奖字典数据
export function marketNhneDict(data) {
    return request({
        url: `exhibitor/Public/marketNhneDict`,
        method: 'get',
    })
}

//获取评奖企业详情
export function nhneCompanydetail(data) {
    return request({
        url: `exhibitor/NhneCompany/detail`,
        method: 'get',
    })
}

//评奖企业编辑
export function editnhneCompany(data) {
    return request({
        url: `exhibitor/NhneCompany/edit`,
        method: 'put',
        data:data
    })
}

//获取评奖产品列表
export function nhneProductlists(data) {
    return request({
        url: `exhibitor/NhneMarketProduct/lists?${data}`,
        method: 'get',
    })
}
//获取评奖产品添加
export function addNhneMarketProduct(data) {
    return request({
        url: 'exhibitor/NhneMarketProduct/add',
        method: 'post',
        data
    })
}
//获取评奖产品详情
export function nhneMarketProductdetail(data) {
    return request({
        url: `exhibitor/NhneMarketProduct/detail?id=${data.id}`,
        method: 'get',
    })
}
//获取评奖产品编辑
export function editnhneMarketProduct(data) {
    return request({
        url: `exhibitor/NhneMarketProduct/edit`,
        method: 'put',
        data:data
    })
}

// 获取评奖 删除产品
export function delNhneMarketProduct(data) {
    return request({
        url: 'exhibitor/NhneMarketProduct/delete',
        method: 'delete',
        data
    })
}
//获取评奖奖项列表
export function nhneMarketAwardslists(data) {
    return request({
        url: `exhibitor/NhneMarketAwards/lists`,
        method: 'get',
    })
}
//获取评奖报名数量
export function getEnrollCount(data) {
    return request({
        url: `exhibitor/NhneMarketAwards/getEnrollCount?${data}`,
        method: 'get',
    })
}
//获取评奖报名详情
export function getEnrollProductDetail(data) {
    return request({
        url: `exhibitor/NhneMarketAwards/getEnrollProductDetail?${data}`,
        method: 'get',
    })
}

//获取评奖同步信息
export function synProductByOM(data) {
    return request({
        url: `exhibitor/NhneMarketProduct/synProductByOM`,
        method: 'get',
    })
}
//获取评奖是否显示nhne菜单
export function menuSwitch(data) {
    return request({
        url: `exhibitor/CompanyMenu/menuSwitch`,
        method: 'get',
    })
}

//获取评奖产品详情
export function upBase64cCode(data) {
    return request({
        url: `exhibitor/Upload/upBase64cCode`,
        method: 'post',
        data:data
    })
}

//获取评奖产品详情
export function savePoster(data) {
    return request({
        url: `exhibitor/NhneMarketAwards/savePoster`,
        method: 'put',
        data:data
    })
}

//获取展位面积是否≥36平米
export function getPurview(data) {
    return request({
        url: `exhibitor/NhneMarketAwards/getPurview`,
    })
}

//产品排序
export function setSort(data) {
    return request({
        url: `exhibitor/product/setSort`,
        method: 'put',
        data:data
    })
}
//获取首页进度
export function myMenuStep() {
    return request({
        url: `exhibitor/company_menu/myMenuStep`,
        method: 'get',
    })
}
//获取未查看的询盘数量
export function getReadNum() {
    return request({
        url: `exhibitor/SeekSample/getReadNum`,
        method: 'get',
    })
}
//获取小程序二维码
export function getUnlimited(data) {
    return request({
        url: `exhibitor/company/getUnlimited?${data}`,
        method: 'get',
        responseType: 'arraybuffer',
    })
}